<template>
  <div class="third">
    <component :is="labelName" :ref="labelName" :ID="OSfailoverId" @backHome="goBackHome" @fatherMethod="fatherMethod"></component>
  </div>
</template>

<script>
import adhibitionJPG from "./components/adhibitionJPG.vue";
// import Loginprompt from "./components/Login-prompt.vue";
// import organization from "./components/organization.vue";
import AlumniOpen from "./components/AlumniOpen.vue";
import AlumniDHTML from "./components/AlumniDHTML.vue";
import AlumniPact from "./components/AlumniPact.vue";
// import OfficialContact from "./components/OfficialContact.vue";
// import UnitInvoiceTitle from "./components/UnitInvoiceTitle.vue";
// import AppUccn from "./components/AppUccn.vue";

export default {
  name: "YXindex",
  data() {
    return {
      labelName: "adhibitionJPG",
      OSfailoverId: ""
    };
  },
  components: {
    adhibitionJPG,
    // Loginprompt,
    // organization,
    AlumniOpen,
    AlumniDHTML,
    AlumniPact,
    // OfficialContact,
    // UnitInvoiceTitle,
    // AppUccn
  },
  created() {},
  methods: {
    // 返回首页
    goBackHome() {
      this.labelName = "adhibitionJPG";
    },
    fatherMethod(labelName){
        this.labelName = labelName;
    }
    // 新增/编辑
    // toAddRole(val) {
    //   this.labelName = 'addyuanxi'
    //   console.log("获取",val)
    //   this.collegeInfoId = val
    // },
  }
};
</script>
